import React, { useCallback, useState } from 'react';
import NativeSelect from '@mui/material/NativeSelect';
import store from './../../../../store';
import { openRequestModal } from '../../../../actions/modals';
import { getErrorNotification } from '../../../../actions/toast';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Field } from 'redux-form';
import { IconButton, Stack, Tooltip } from '@mui/material';
import MoveUpIcon from '@mui/icons-material/MoveUp';


const BLOCKED_STATUSES_FOR_CANDIDATE_GROUP = [0, 1, 4, 7];

const getGroupDisplayName = (group, language) => {
    if (!group || !group.title) return '';
    if (typeof group.title === 'object') {
        return group.title[language] || Object.values(group.title).find(Boolean) || String(group.id);
    }
    return group.title;
};

const renderTextField = ({ input, meta: { touched, error }, i18n, selectionError, ...custom }) => {
    // eslint-disable-next-line
    const groups =
        (store.getState().groups && store.getState().groups.select && store.getState().groups.select.list) || [];

    const group = groups.find(el => +el.id === +input.value);
    return (
        <NativeSelect
            {...input}
            {...custom}
            error={selectionError}
            sx={{ minWidth: '200px' }}
        >
            {!group ? <option value={-1}>{i18n.t('groups.no_group_link')}</option> : null}
            {groups.map((item, key) => {
                const title =
                    item.title && typeof item.title === 'object'
                        ? item.title[i18n.language] || Object.values(item.title).find(Boolean) + ' (not translated)'
                        : item.title;

                return (
                    <option key={key} value={item.id}>
                        {title}
                    </option>
                );
            })}
        </NativeSelect>
    );
    // ChangeStudentGroup
};

export default ({ value, code, id }) => {
    const history = useHistory();
    const { i18n } = useTranslation();
    const [selectionError, setSelectionError] = useState(false);

    const handleDoubleClick = useCallback(value => {
        history.push(`/groups/${value}`);
    });
    return (
        <Stack direction="row" spacing={1}>
            <Tooltip title={i18n.t('table.goToGroup')}>
                <IconButton
                    onClick={() => {
                        handleDoubleClick(value);
                    }}
                >
                    <MoveUpIcon />
                </IconButton>
            </Tooltip>
            <Field
                name={JSON.stringify({ code, id })}
                onChange={event => {
                    event.preventDefault();

                    const newGroupId = event.target.value;
                    if (+newGroupId === -1) return;

                    const storeState = store.getState();
                    const groups =
                        (storeState.groups && storeState.groups.select && storeState.groups.select.list) || [];
                    const selectedGroup = groups.find(el => +el.id === +newGroupId);

                    if (selectedGroup && +selectedGroup.course_type === 1) {
                        const tableData =
                            (storeState.AsyncTable &&
                                storeState.AsyncTable.table &&
                                storeState.AsyncTable.table.data) ||
                            [];
                        const student = tableData.find(el => +el.id === +id);

                        if (student && BLOCKED_STATUSES_FOR_CANDIDATE_GROUP.includes(student.status)) {
                            getErrorNotification(i18n.t('error.candidate_group_transfer'));
                            setSelectionError(true);
                            return;
                        }
                    }

                    setSelectionError(false);
                    const groupName = getGroupDisplayName(selectedGroup, i18n.language);
                    store.dispatch(
                        openRequestModal({
                            opened: true,
                            data: {
                                header: i18n.t('groups.transfer_student'),
                                modaltype: 'ConfirmStudentTransferModal',
                                groupName,
                                code,
                                id,
                                newGroupId,
                            },
                        })
                    );
                }}
                selectionError={selectionError}
                i18n={i18n}
                component={renderTextField}
                type="text"
            />
        </Stack>
    );
};
